export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

export const FIRST_TOUCH_STORAGE_KEY = 'specific_acquisition_first_touch_v1';
export const FIRST_TOUCH_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
const UTM_VALUE_MAX_LENGTH = 160;

function normalizeValue(value) {
  if (value === null || value === undefined) return '';
  const printable = Array.from(String(value).normalize('NFKC'))
    .map((character) => {
      const code = character.charCodeAt(0);
      return code <= 31 || code === 127 ? ' ' : character;
    })
    .join('');
  return printable
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .slice(0, UTM_VALUE_MAX_LENGTH);
}

export function normalizeUtm(value) {
  const source = value && typeof value === 'object' ? value : {};
  return UTM_KEYS.reduce((utm, key) => {
    const normalized = normalizeValue(source[key]);
    if (normalized) utm[key] = normalized;
    return utm;
  }, {});
}

export function utmFromSearch(search = '') {
  const params = new URLSearchParams(String(search).replace(/^\?/, ''));
  return normalizeUtm(
    UTM_KEYS.reduce((utm, key) => {
      utm[key] = params.get(key) || '';
      return utm;
    }, {}),
  );
}

export function getFirstTouchUtm(
  search = typeof window !== 'undefined' ? window.location.search : '',
  storage = typeof window !== 'undefined' ? window.localStorage : null,
  now = Date.now(),
) {
  const current = utmFromSearch(search);

  if (storage) {
    try {
      const stored = storage.getItem(FIRST_TOUCH_STORAGE_KEY);
      if (stored) {
        const envelope = JSON.parse(stored);
        const capturedAt = Number(envelope?.captured_at);
        const storedUtm = normalizeUtm(envelope?.utm);
        const age = now - capturedAt;
        const isCurrent = Number.isFinite(capturedAt)
          && age >= 0
          && age <= FIRST_TOUCH_MAX_AGE_MS;

        if (isCurrent && Object.keys(storedUtm).length > 0) {
          return storedUtm;
        }

        storage.removeItem(FIRST_TOUCH_STORAGE_KEY);
      }
    } catch (_error) {
      // Storage can be unavailable or contain stale data; recapture safely.
    }
  }

  if (storage && Object.keys(current).length > 0) {
    try {
      storage.setItem(FIRST_TOUCH_STORAGE_KEY, JSON.stringify({
        utm: current,
        captured_at: now,
      }));
    } catch (_error) {
      // Attribution must never block the landing form.
    }
  }
  return current;
}

export function clearFirstTouchUtm(
  storage = typeof window !== 'undefined' ? window.localStorage : null,
) {
  if (!storage) return;
  try {
    storage.removeItem(FIRST_TOUCH_STORAGE_KEY);
  } catch (_error) {
    // A successful request must not depend on browser storage.
  }
}
